import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream py-12 sm:py-24" data-id="element-161" data-mp="zp42d7umirww">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-162" data-mp="uq9evslpof6g">
        <h2 className="text-center font-serif text-[1.9rem] text-petrol-800 sm:text-5xl" data-id="element-163" data-mp="usvtudaxlwyp">Preguntas frecuentes</h2>
        <ul className="mt-6 border-t border-beige-300 sm:mt-12" data-id="element-164" data-mp="22544soa9bww">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="border-b border-beige-300" data-id="element-165" data-mp="h0flcwz9h6qe" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-4 text-left sm:py-5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terra-500" data-id="element-166" data-mp="bzrzeppw3g31">
                  <span className="font-serif text-lg text-petrol-800 sm:text-2xl" data-id="element-167" data-mp="htzes18ehrp7">{faq.question}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-terra-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-168" data-mp="msaqkhi9aca2" />
                </button>
                <AnimatePresence initial={false} data-id="element-169" data-mp="vt8m0bempbh1">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-170" data-mp="vspbvgv7zrdk">
                      <p className="pb-6 pr-8 leading-relaxed text-ink/70" data-id="element-171" data-mp="3ci4a7nai94d5">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}